<div class="control-buttons">

	<form>

		<mat-form-field appearance="outline" class="date-search">
			<mat-label>Global Search</mat-label>
			<input matInput [formControl]="globalSearch" (keyup.enter)="onEnterKey()">

			@if (globalSearch.getRawValue()) {
			<button matSuffix matIconButton class="mat-clear" aria-label="Clear" (click)="clickGlobalSearchX($event)">
				<mat-icon>close</mat-icon>
			</button>
			}
		</mat-form-field>

		<mat-paginator (page)="onPageChange($event)" [pageSize]="10"
			[pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page">
		</mat-paginator>

		<span [matTooltip]="tooltipText" matTooltipPosition="below">
			<button class="control-button" mat-flat-button [disabled]="disabled" (click)="newMacro()">New</button>
		</span>
		<span [matTooltip]="tooltipText" matTooltipPosition="below">
			<button class="control-button" mat-flat-button [disabled]="disabled" (click)="importMacros()">Import</button>
		</span>

	</form>
</div>

<table mat-table [dataSource]="voiceMacroDataSource">

	<ng-container matColumnDef="actions">
		<th mat-header-cell *matHeaderCellDef> Actions </th>
		<td mat-cell *matCellDef="let element">
			<button mat-icon-button color="primary" (click)="editItem(element)">
				<mat-icon>edit</mat-icon>
			</button>
			<button mat-icon-button color="primary" (click)="deleteItem(element)">
				<mat-icon>delete</mat-icon>
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="id">
		<th mat-header-cell *matHeaderCellDef>id</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.id}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="section">
		<th mat-header-cell *matHeaderCellDef>Section</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.section}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="phrase">
		<th mat-header-cell *matHeaderCellDef>Phrase</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.phrase }}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="substitution">
		<th mat-header-cell *matHeaderCellDef>Substitution</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.substitution }}</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns;">

</table>
